import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetChargePointsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/get-charge-points-paginated.form-default-values';
import { GetChargePointsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/get-charge-points-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchChargePointListContextProvider,
  useChargePointListContext,
} from '../charge-point.context';
import { ChargePointListFilterSearchFormController } from './charge-point-list-filter-search-form/charge-point-list-filter-search-form.controller';

interface ChargePointListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const ChargePointListFilterSearchController = ({
  onCancel,
  onSuccess,
}: ChargePointListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useChargePointListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetChargePointsPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.charge-point-list-filter-search.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetChargePointsPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        textToSearch: fieldValues.textToSearch,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetChargePointsPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterSearchChargePointListContextProvider data={data}>
      <ChargePointListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchChargePointListContextProvider>
  );
};
